import React, { useEffect } from 'react';
import AOS from 'aos';
import CommonIn from '../utils/CommonIn';

// import 'aos/dist/aos.css';
// import 'assets/css/common.css';
// import 'assets/css/dreamt1.css';
// import 'assets/css/aos.css';

const Service = () => {
  useEffect(() => {
    const handleLoad = () => {
      AOS.init();
      CommonIn();
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
    }

    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, []);

  return (
    <>
      
      <main className="submain" id="submain">
        <div className="sub_header">
          <div className="container sub_header_inner">
            <h1>서비스</h1>
          </div>
        </div>
        <div className="submenu">
          <div className="container">
            <div className="submenu_inner">
              <ul>
                <li><a href="#ser_manage">일용직 근태관리</a></li>
                <li><a href="#ser_stu">학원생 출결관리</a></li>
                <li><a href="#ser_api">얼굴인식 API</a></li>
              </ul>
            </div>
          </div>
        </div>
        <section className="visual_sec solution_vs">
          <div className="container visual_inner">
            <div className="visual_text">
              <h2>"현장을 연결하고, 운영을 자동화합니다."</h2>
              <p>출결부터 근태, 얼굴인식 API까지<br />다양한 환경에 최적화된 스마트 운영 서비스를 제공합니다.</p>
            </div>
          </div>
        </section>
        <section className="sol_wrap snlink" id="ser_manage">
          <div className="container">
            <div className="sol_tit_box">
              <p className="sol_tit">일용직 인력관리,<br />자동화가 답입니다.</p>
              <p>얼굴인식과 인증 데이터 기반의 출입 관리로<br />복잡한 권한 설정부터 이력 추적까지,<br />정확하고 신뢰할 수 있는 보안 환경을 제공합니다.</p>
            </div>
            <div>
              <div className="row">
                <div className="col">
                  <div className="icon"><img src="../assets/images/ser01_icon01.png" alt="근로자 아이콘" /></div>
                  <h3>쉬운 근로자 등록</h3>
                  <p>모바일 기반 근로자 정보 등록<br />등록 정보 조회 및 대면 검증</p>
                </div>
                <div className="col">
                  <div className="icon"><img src="../assets/images/ser01_icon02.png" alt="근로 계약서 아이콘" /></div>
                  <h3>편리한 전자 근로 계약서</h3>
                  <p>다양한 형식의 계약서 지원<br />출근 연계 계약서 작성 지원<br />모바일 계약서 확인 및 다운로드 지원</p>
                </div>
                <div className="col">
                  <div className="icon"><img src="../assets/images/ser01_icon03.png" alt="문진표 작성 아이콘" /></div>
                  <h3>보건 문진표 작성 지원</h3>
                  <p>출근 전 보건 문진표 작성 지원<br />기구축된 보건 시스템 연계 지원</p>
                </div>
                <div className="col">
                  <div className="icon"><img src="../assets/images/ser01_icon04.png" alt="인프라 아이콘" /></div>
                  <h3>확장성 좋은 AWS 인프라</h3>
                  <p>오토스케일 기반 서버 확장성<br />빠른 인프라 구성</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="sol_wrap snlink" id="ser_stu">
          <div className="container">
            <div className="sol_tit_box">
              <p className="sol_tit">"출결 관리,<br />생체인식으로 더 스마트하게"</p>
              <p>생체정보와 신분 검증을 결합한 고정밀 인증 시스템으로<br />연령 제한 콘텐츠 및 서비스 이용 시,<br />법적 요건을 완벽히 충족하는 인증 환경을 제공합니다.</p>
            </div>
            <div>
              <div className="row">
                <div className="col">
                  <div className="icon"><img src="../assets/images/ser02_icon01.png" alt="학원생 아이콘" /></div>
                  <h3>학원관리 시스템 연동<br />학원생 등록 지원</h3>
                  <p>국내 Top 학원관리 시스템(AKA2000)</p>
                </div>
                <div className="col">
                  <div className="icon"><img src="../assets/images/ser02_icon02.png" alt="출결 인증 아이콘" /></div>
                  <h3>다양한 출입인증 장치 연계<br />출결 인증 지원</h3>
                  <p>얼굴인식기/지문인식기/RF리더<br />모바일 신분증</p>
                </div>
                <div className="col">
                  <div className="icon"><img src="../assets/images/ser02_icon03.png" alt="리포팅 아이콘" /></div>
                  <h3>출결인식 결과 리포팅</h3>
                  <p>SMS 발송, 시스템 연계 리포팅</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="sol_wrap snlink" id="ser_api">
          <div className="container">
            <div className="sol_tit_box">
              <p className="sol_tit">얼굴인식 기능,<br />당신의 서비스에<br />바로 연결하세요</p>
              <p>AI 인증 기술과 직관적인 UI를 기반으로<br />무인 접수·출입·확인을 자동화하여 현장 운영 효율성과<br />사용자 만족도를 동시에 높입니다.</p>
            </div>
            <div>
              <div className="row">
                <div className="col">
                  <div className="icon"><img src="../assets/images/ser03_icon01.png" alt="성능 아이콘" /></div>
                  <h3>뛰어난 성능</h3>
                  <p>ETRI 기술 이전 엔진 사용</p>
                </div>
                <div className="col">
                  <div className="icon"><img src="../assets/images/ser03_icon02.png" alt="개인정보 아이콘" /></div>
                  <h3>안전한 개인정보 관리</h3>
                  <p>KISA 얼굴인식 인증 제품</p>
                </div>
                <div className="col">
                  <div className="icon"><img src="../assets/images/ser03_icon03.png" alt="개인정보 아이콘" /></div>
                  <h3>안전한 개인정보 관리</h3>
                  <p>드림시큐리티 인증 암호 솔루션 사용</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
     
    </>
  );
};

export default Service;